import api from '../callApi';

const completeLink = (apiRequestData, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime
    };

    return api.post('Widget/CompleteLinkAsync', request).then(response => {
        return response;
    });
};

export default completeLink;



// WEBPACK FOOTER //
// ./src/utils/link/linkApi.js